import React from 'react'

export default function ActionCheckbox({ 
    page = '',
    companies = [],
    users = [],
    accounts = [],
    checkedItems = [],
    setCheckedItems = () => {},
    selectAll = false,
    setSelectAll = () => {},
    related_id = ''
}) {
    const handleCheckboxChange = (id) => {
        const updatedCheckedItems = checkedItems.includes(id)
            ? checkedItems.filter((itemId) => itemId !== id)
            : [...checkedItems, id];

        setCheckedItems(updatedCheckedItems);
    };

    // Handle "Select All" for the current page
    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);
        if (newSelectAll) {
            if(page == 'companies' && companies.length > 0){
                setCheckedItems(companies.map((item) => item.id)); // Select all items on current page
            }else if(page == 'users' && users.length > 0){
                setCheckedItems(users.map((item) => item.id)); // Select all items on current page
            }else if(page == 'accounts' && accounts.length > 0){
                setCheckedItems(accounts.map((item) => item.id)); // Select all items on current page
            }else{
                setCheckedItems([]);
            }
        } else {
            setCheckedItems([]); // Deselect all items on current page
        }
    };

    return (
        <>
            <input
                type="checkbox"
                checked={related_id !== '' ? checkedItems.includes(related_id) : selectAll}
                onChange={() => related_id !== '' ? handleCheckboxChange(related_id) : handleSelectAll()}
            />
        </>
    )
}
